<template>
    <div class="filters" v-click-outside="clearActiveFilter">
        <h3 class="filters__heading hide-desktop">Filters</h3>
        <div class="filters__cat" v-for="(item, i) in items" :key="i">
            <div class="filters__cat-label" :class="{'filters__cat-label--open': activeFilter === i}" @click="show(i)">
                <span>{{item.optionsLabel}}</span>
                <i class="icon-chevron-down"></i>
            </div>
            <div class="filters__list" ref="filtersList" style="height: 0;">
                <div class="filters__filters" :class="{'filters__filters--open': activeFilter === i}">
                    <div class="filters__check" v-for="(option, j) in item.options" :key="j">
                        <div class="filters__select">
                            <input class="filters__checkbox" type="checkbox" :checked="option.checked" @click="select($event, option.all, i, j)"/>
                            <div class="filters__checkbox-decoration">
                                <i class="icon-play-check"></i>
                            </div>
                            <label :class="{ active: option.checked }">{{option.label}}</label>
                        </div>
                        <span class="filters__count" :class="{ active: option.checked }">{{option.count}}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  import ClickOutside from 'vue-click-outside';
  import {EventBus} from '../../eventbus';

  export default {
    name: 'Filters',

    directives: {
      ClickOutside
    },

    props: {
      kind: String,
      options: Array,
      type: String
    },

    data: () => {
      return {
        activeFilter: false,
        items: []
      }
    },

    watch: {
      activeFilter: function(newVal, oldVal) {
        let filtersList = this.$refs.filtersList;

        Object.keys(filtersList).forEach(function (filterKey) {
          const key = parseInt(filterKey,10);
          if (key === newVal) {
            filtersList[key].style.height = filtersList[key].scrollHeight + 'px';
          } else {
            filtersList[key].style.height = '0';
          }
        });

      }
    },

    mounted() {
      this.items = [ ...this.options ];
    },

    methods: {
      clearActiveFilter: function () {
        this.activeFilter = false;
      },
      show: function (i) {
        if (i === this.activeFilter) {
          this.clearActiveFilter();
        } else {
          this.activeFilter = i;
        }
      },
      select: function (e, all, i, j) {
        if(this.type === 'cat') {
          this.$store.dispatch('updateFilterCategories', {
            e,
            all,
            i,
            j,
            type: this.kind,
            data: this.items,
            cause_id: this.$route.params.cause_id,
            id: 'categories'
          }, { root: true });
        } else if(this.type === 'items') {
          this.$store.dispatch('updateFilterItems', {
            e,
            all,
            i,
            j,
            data: this.items,
            cause_id: this.$route.params.cause_id,
            id: 'items'
          }, { root: true });
        }
      },
    }
  }
</script>
